import { useTranslation } from "react-i18next";

import { Accordion } from "@shared/components";

import { FieldDiffRow } from "./components";

import styles from "./method-accordion.module.css";

import type { MethodAccordionProps } from "./method-accordion.type";

export const MethodAccordion = ({
  id,
  icon: Icon,
  title,
  changes,
  count,
  extraContent,
}: MethodAccordionProps) => {
  const { t } = useTranslation();

  const totalCount = count ?? changes.length;
  const hasExtraContent = Boolean(extraContent);

  if (changes.length === 0 && !hasExtraContent) return null;

  const countLabel =
    totalCount === 1
      ? t("payfac.pageRatePlanHistoryModalChangeCountSingular", {
        count: totalCount,
      })
      : t("payfac.pageRatePlanHistoryModalChangeCountPlural", {
        count: totalCount,
      });

  const header = (
    <div className={styles['header-core']}>
      <span className={styles.icon}>
        <Icon size={20} weight="regular" />
      </span>
      <span className={styles.title}>{title}</span>
      <span className={styles.count}>{countLabel}</span>
    </div>
  );

  return (
    <Accordion.Item
      id={id}
      header={header}
      headerClassName={styles.header}
      className={styles.item}
      contentClassName={styles.content}
    >
      {changes.map((diff) => (
        <FieldDiffRow
          key={diff.fieldKey}
          label={t(diff.labelKey)}
          diff={diff}
        />
      ))}
      {extraContent}
    </Accordion.Item>
  );
};
